import { toast } from 'react-toastify';
import { userService } from '../services';
import { userConst } from '../consts';
import { history } from '../history';
import { showErrorsIfNeed } from './utils';

const URL_PREFIX = process.env.PUBLIC_URL;

export const userActions = {
    login: loginUser,
    loginByVk: loginUserByVk,
    register: registerUser,
    logout: logoutUser,
    checkSession,
    update,
    clearErrors,
};

function loginUser(username, password) {
    return (dispatch) => {
        dispatch(request());

        userService.login(username, password).then(
            (user) => {
                dispatch(success(user));
                toast.success(`Успешная авторизация`);
                if (history.location.pathname.endsWith('/login')) history.push(`${URL_PREFIX}/`);
            },
            (error) => {
                dispatch(failure(error));
                showErrorsIfNeed(error, [400, 404]);
            }
        );
    };

    function request() {
        return { type: userConst.LOGIN_REQUEST };
    }

    function success(user) {
        return { type: userConst.LOGIN_SUCCESS, user };
    }

    function failure(error) {
        let errors;
        if (error.status === 400) errors = error.errors;
        else if (error.status === 404) errors = { globalError: 'Указаны неправильные логин или пароль' };
        return {
            type: userConst.LOGIN_FAILURE,
            errors,
        };
    }
}

/**
 * Авторизация по данным VK.
 * @param data {object}
 * @param data.userId {number}
 * @param data.token {string}
 * @param data.uuid {string}
 * @param skipFirstEvent {boolean}
 * @returns {(function(*): void)|*}
 */
function loginUserByVk(data, skipFirstEvent = false) {
    return (dispatch) => {
        if (!skipFirstEvent) dispatch(request());

        userService.loginByVk(data).then(
            (user) => {
                dispatch(success(user));
                toast.success(`Успешная авторизация`);
                if (history.location.pathname.endsWith('/login')) history.push(`${URL_PREFIX}/`);
            },
            (error) => {
                dispatch(failure(error));
                showErrorsIfNeed(error, [400, 404]);
            }
        );
    };

    function request() {
        return { type: userConst.LOGIN_REQUEST };
    }

    function success(user) {
        return { type: userConst.LOGIN_SUCCESS, user };
    }

    function failure(error) {
        let errors;
        if (error.status === 400) errors = error.errors;
        else if (error.status === 404) errors = { globalError: 'Указаны неправильные логин или пароль' };
        return {
            type: userConst.LOGIN_FAILURE,
            errors,
        };
    }
}

function registerUser(userData) {
    return (dispatch) => {
        dispatch(request(userData));

        userService.register(userData).then(
            (data) => {
                dispatch(success(data));
                toast.success(`Успешная регистрация`);
                if (data.status === 'mail_sent') history.push(`${URL_PREFIX}/message/reg_mail_sent`);
            },
            (error) => {
                dispatch(failure(error));
                showErrorsIfNeed(error);
            }
        );
    };

    function request(user) {
        return { type: userConst.REGISTER_REQUEST, user };
    }

    function success() {
        return { type: userConst.REGISTER_SUCCESS };
    }

    function failure(error) {
        return { type: userConst.REGISTER_FAILURE, errors: error.status === 400 ? error.errors : null };
    }
}

function logoutUser() {
    userService.logout();
    return { type: userConst.LOGOUT };
}

function checkSession() {
    return (dispatch, getState) => {
        const vkPayload = getVkPayloadAndClearUrlParams();
        userService.getInfo().then(
            (user) => {
                const {
                    auth: { user: oldUser },
                } = getState();
                if (user !== oldUser && JSON.stringify(user) !== JSON.stringify(oldUser)) dispatch(success(user));
                if (history.location.pathname.endsWith('/login')) history.push(`${URL_PREFIX}/`);
            },
            (error) => {
                const {
                    auth: { initing },
                } = getState();
                if (initing && vkPayload) {
                    return dispatch(
                        loginUserByVk(
                            {
                                token: vkPayload.token,
                                uuid: vkPayload.uuid,
                                userId: vkPayload.user.id,
                            },
                            true
                        )
                    );
                }
                if (error.status === 401 || initing) dispatch(failure());
                showErrorsIfNeed(error, [401]);
            }
        );
    };

    function success(user) {
        return { type: userConst.LOGIN_SUCCESS, user };
    }

    function failure() {
        return { type: userConst.LOGOUT };
    }
}

function update({ field, value, params }) {
    return (dispatch) => {
        dispatch(request());

        userService.update({ field, value, params }).then(
            (user) => {
                dispatch(success(user));
                toast.success(`Изменение успешно`);
            },
            (error) => {
                dispatch(failure(error));
                showErrorsIfNeed(error, [400]);
            }
        );
    };

    function request() {
        return { type: userConst.CHANGE_REQUEST };
    }

    function success(user) {
        return { type: userConst.CHANGE_SUCCESS, user };
    }

    function failure(error) {
        let errors;
        if (error.status === 400) errors = error.errors;
        return {
            type: userConst.CHANGE_FAILURE,
            errors,
        };
    }
}

function clearErrors() {
    return { type: userConst.CLEAR_ERRORS };
}

function getVkPayloadAndClearUrlParams() {
    const urlParams = new URLSearchParams(window.location.search);
    const vkPayloadStr = urlParams.get('payload');
    if (!vkPayloadStr) return null;
    window.history.replaceState(
        null,
        '',
        window.location.protocol + '//' + window.location.host + window.location.pathname
    );
    try {
        const vkPayload = JSON.parse(vkPayloadStr);
        if (vkPayload.token && vkPayload.uuid && vkPayload.user.id) {
            return vkPayload;
        }
        return null;
    } catch (e) {
        console.error('Error of parsing vk payload: ' + e.message, vkPayloadStr);
        return null;
    }
}
